import request from "../lib/request";
import {
  AccountType,
  LogType,
  OrderType,
  TemplateType,
  SenderType,
  ShopType,
  ProductType,
  TaskType,
} from "~@/types/fake";
import { SafeResponseType, PageResponseType } from "~@/types/universal";

export const getOrderList = (
  params: {
    currentPage: number;
    pageSize: number;
  },
  controller?: AbortController
): Promise<SafeResponseType<PageResponseType<OrderType>>> => {
  return request
    .get("/order-pagination", {
      params,
      ...(controller ? { signal: controller.signal } : {}),
    })
    .then((res) => res.data);
};

export const getPrintLogs = (
  params: {
    currentPage: number;
    pageSize: number;
  },
  controller?: AbortController
): Promise<SafeResponseType<PageResponseType<LogType>>> => {
  return request
    .get("/printlog-pagination", {
      params,
      ...(controller ? { signal: controller.signal } : {}),
    })
    .then((res) => res.data);
};

export const getTemplates = (
  params: {
    currentPage: number;
    pageSize: number;
  },
  controller?: AbortController
): Promise<SafeResponseType<PageResponseType<TemplateType>>> => {
  return request
    .get("/template-pagination", {
      params,
      ...(controller ? { signal: controller.signal } : {}),
    })
    .then((res) => res.data);
};

export const getAccounts = (
  params: {
    currentPage: number;
    pageSize: number;
  },
  controller?: AbortController
): Promise<SafeResponseType<PageResponseType<AccountType>>> => {
  return request
    .get("/account-pagination", {
      params,
      ...(controller ? { signal: controller.signal } : {}),
    })
    .then((res) => res.data);
};

export const getsenders = (
  params: {
    currentPage: number;
    pageSize: number;
  },
  controller?: AbortController
): Promise<SafeResponseType<PageResponseType<SenderType>>> => {
  return request
    .get("/sender-pagination", {
      params,
      ...(controller ? { signal: controller.signal } : {}),
    })
    .then((res) => res.data);
};

export const getShops = (
  params: {
    currentPage: number;
    pageSize: number;
  },
  controller?: AbortController
): Promise<SafeResponseType<PageResponseType<ShopType>>> => {
  return request
    .get("/shop-pagination", {
      params,
      ...(controller ? { signal: controller.signal } : {}),
    })
    .then((res) => res.data);
};

export const logout = () => {
  localStorage.removeItem("account");
  return Promise.resolve({
    success: true,
    error: null,
  } as {
    success: boolean;
    error: Error | null;
  });
};

export const getProducts = (
  params: {
    currentPage: number;
    pageSize: number;
  },
  controller?: AbortController
): Promise<SafeResponseType<PageResponseType<ProductType>>> => {
  return request
    .get("/products", {
      params,
      ...(controller ? { signal: controller.signal } : {}),
    })
    .then((res) => res.data);
};


export const postForm = (data:any)=>{
  return request.post("/form",data).then((res) => res.data);
}

export const getTasks = (
  params: {
    currentPage: number;
    pageSize: number;
  },
  controller?: AbortController
): Promise<SafeResponseType<PageResponseType<TaskType>>> => {
  return request
    .get("/tasks", {
      params,
      ...(controller ? { signal: controller.signal } : {}),
    })
    .then((res) => res.data);
};

export const cancelTask = (data:any)=>{
  return request.post("/cancel-task",data).then((res) => res.data);
}